module.exports = __webpack_public_path__ + "img/20191218155203360截图20191218105827045.5ce27ac1.jpg";